import { Alert, Box } from '@qbe/ads-core';
import React from 'react';

import { useAppContent } from '~/hooks';

interface AddressValidationAlertsProps {
  isError: boolean;
  isWarning: boolean;
}

const AddressValidationAlerts: React.FC<AddressValidationAlertsProps> = ({
  isError,
  isWarning,
}) => {
  const { getTextContent } = useAppContent({
    basePath: 'dsme.addressComponent',
  });

  return (
    <Box sx={{ paddingTop: isError || isWarning ? 2 : 0 }}>
      {isError && (
        <Alert variant="error" heading={getTextContent('alerts.manualAddressError.title')} />
      )}
      {isWarning && (
        <Alert variant="warning" heading={getTextContent('alerts.manualAddressWarning.title')} />
      )}
    </Box>
  );
};

export default AddressValidationAlerts;
